export const shadows = {
  Intro: "#AD4545",
  Verse: "#C16A4D",
  Prechorus: "#D69656",
  Refrain: "#D3B455",
  Chorus: "#D1D153",
  Bridge: "#B8D857",
  Outro: "#A3E85D",
  "Re-in": "#59DD9B",
  Solo: "#5BE3E3",
  Interlude: "#5594D3"
};
